import type { ParsedUrlQuery } from 'querystring';

import type { FC } from 'react';
import React from 'react';
import LazyLoad from 'react-lazyload';

import type { AffSub4 } from '@src/@types/microcredits';
import { isServer } from '@src/utils';
import { useAdvertisingPixel } from 'app/providers/AdvertisingProvider';

import styles from './styles.module.scss';

interface IPixelProps {
  link?: string;
  sub?: string;
  source?: string;
  affSub4: AffSub4;
  propogationParams?: ParsedUrlQuery;
  wrapperStyles?: React.CSSProperties;
}

const PixelImage = ({ link, source, sub, affSub4, propogationParams }: Omit<IPixelProps, 'wrapperStyles'>) => {
  const { getPixelLink } = useAdvertisingPixel();
  const src = getPixelLink(link, { source, sub, affSub4, propogationParams });

  if (!link || !src || isServer) {
    return null;
  }

  return <img className={styles.pixel} alt="" src={src} />;
};

export const Pixel: FC<IPixelProps> = ({ wrapperStyles, ...props }) => (
  <LazyLoad style={wrapperStyles}>
    <PixelImage {...props} />
  </LazyLoad>
);
